import { NavLink, useLocation } from "react-router-dom";
import { cn } from "../utils/cn";

interface DesktopNavTab {
  label: string;
  route: string;
  isActive: (pathname: string) => boolean;
}

const NAV_TABS: DesktopNavTab[] = [
  {
    label: "Dashboard",
    route: "/dashboard",
    isActive: (pathname) => pathname === "/" || pathname === "/dashboard",
  },
  {
    label: "Settings",
    route: "/settings",
    isActive: (pathname) => pathname.startsWith("/settings"),
  },
];

/**
 * Desktop horizontal navigation links with animated active indicator.
 *
 * Renders inside the desktop header between the logo and avatar area.
 * Each link shows a 2px bottom bar (pill indicator) when active,
 * with a `scale-x` transition for smooth activation.
 *
 * Hidden on mobile (md+ only via parent layout).
 */
export function DesktopNav() {
  const location = useLocation();

  return (
    <nav
      className="desktop-header-nav"
      id="desktop-nav"
      aria-label="Main navigation"
    >
      {NAV_TABS.map((tab) => {
        const active = tab.isActive(location.pathname);
        return (
          <NavLink
            key={tab.label}
            to={tab.route}
            className={cn(
              "desktop-nav-link",
              active && "desktop-nav-link--active"
            )}
            {...(active ? { "aria-current": "page" as const } : {})}
          >
            {tab.label}
          </NavLink>
        );
      })}
    </nav>
  );
}
